module.exports = __webpack_public_path__ + "img/banner2.d2d2e83b.jpg";